import { ConfirmationDialogData } from './models';

export const DEFAULT_CONFIRMATION_DATA: ConfirmationDialogData = {
  title: 'Confirmation',
  message: 'Are you sure?',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
};
